import { gql } from '@apollo/client';

export const UNPUBLISH_MONITORINGFORM = gql`
  mutation UnpublishMonitoringForm($id: ID!) {
    monitoringForm: unpublishMonitoringForm(id: $id) {
      id
      published
    }
  }
`;
